import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';
import withFormatter from '@concur/nui-intl/lib/components/withFormatter';

export default (WrappedComponent) => {
    const Component = (props) => <WrappedComponent {...props} />;

    const name = WrappedComponent.displayName || WrappedComponent.name;

    hoistNonReactStatics(Component, WrappedComponent);
    Component.displayName = name || 'withNuiFormatter';

    /*
        We are using a non-breaking space to maintain the height of the text
        while the message bundle is loading.  This helps keep the Header and Footer
        the right height while the page is initially rendered.
    */
    Component.defaultProps = {
        formatter: {
            formattedMessage: () => <>&nbsp;</>,
        },
    };
    const wrappedComponent = withFormatter(Component);
    hoistNonReactStatics(wrappedComponent, Component);
    wrappedComponent.displayName = Component.displayName;
    return wrappedComponent;
};
